<template>
  <div class="context-type" :class="{ selected: isCurrentContextType }" @click="selectType">
    <div class="context-type-name">
      <div>
        {{ title }}
        <span>{{ nrOfTactics }}</span>
      </div>
      <div v-if="currentContextName" class="selected-label">
        <div>
          {{ currentContextName }}
        </div>
      </div>
    </div>
    <BbBtn
      :class="['arrow-button', { 'arrow-button-active': isCurrentContextType }]"
      size="x-small"
      type="icon"
      icon="chevron-right"
      icon-size="small"
      no-background
    />
  </div>
</template>

<script>
import { computed } from 'vue';
import useAuthoring from '@/composables/useAuthoring';

export default {
  props: {
    contextType: {
      type: Object,
      default: () => {},
    },
    nrOfTactics: {
      type: Number,
      default: 0,
    },
    selectedContextTypeId: {
      type: String,
      default: '',
    },
  },

  setup(props, { emit }) {
    const { tacticContextFilters } = useAuthoring();

    const isCurrentContextType = computed(() => props.contextType.id === props.selectedContextTypeId);
    const currentContextName = computed(() => tacticContextFilters.value[props.contextType.id]?.name);
    const title = computed(() => props.contextType.title);

    const selectType = () => emit('set-selected-type', props.contextType.id);

    return {
      isCurrentContextType,
      title,
      selectType,
      currentContextName,
    };
  },
};
</script>

<style scoped lang="scss">
.context-type:hover {
  background-color: $bb-neutral-4;
}

.selected {
  background-color: $bb-neutral-4;
}

.context-type {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
  cursor: pointer;
  padding: 0 $bb-spacing-3;
  height: 44px;
  border-radius: 12px;

  &:hover {
    background-color: $bb-neutral-6;
  }

  .arrow-button {
    border: none !important;

    :deep(.v-btn__content) {
      display: none;
    }

    &:hover {
      background: transparent !important;
    }
  }

  .arrow-button-active {
    :deep(.v-btn__content) {
      display: block;

      i {
        color: $bb-neutral-1;
      }
    }
  }

  .context-type-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    span {
      color: $bb-neutral-2;
    }

    .selected-label {
      border-radius: 8px;
      border: 1px solid $bb-neutral-2;
      background: $bb-neutral-0;
      height: 16px;
      display: flex;
      align-items: center;
      padding: 4px 8px;

      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        width: fit-content;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        max-width: 50px;
      }
    }

    @include bb-medium-text-styles('md');
    line-height: $bb-spacing-5;
    color: $bb-neutral-1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }
}
</style>
